import { FormControl } from '@angular/forms';

/** An input should not contain only whitespaces */
export function whitespaceValidator(control: FormControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { 'whitespace': true } : null;
}


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/shared/whitespace-validator.ts